<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="tipoICMSs"
        :headers="headers"
        :rotina-id="ID_TELA_DE_TIPO_ICMS"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarTipoICMS()"
        @update="(indice) => abrirDialogEditarTipoICMS(indice)"
        @delete="(indice) => openDialogDeleteTipoICMS(indice)"
      />
      <DialogDeEdicaoDeTipoICMS
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :tipo-icms-param="tipoICMSParam"
        :itens="itensParam"
        @confirmado="atualizarTipoICMS"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteTipoICMS" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="tipoICMSDelete">
            Tem certeza que deseja excluir o TipoICMS <b> {{ tipoICMSDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteTipoICMS = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerTipoICMS">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import TipoICMSService from '../../../services/tipoicms/tipoicms'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeTipoICMS from '../../../components/tipoicms/DialogDeEdicaoDeTipoICMS'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import TipoICMS from '../../../models/tipoicms'
import { ID_TELA_DE_TIPO_ICMS } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeTipoICMS
  },
  data: () => ({
    name: 'TelaDeTipoICMS',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' }
    ],
    tipoICMSs: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    tipoICMSParam: new TipoICMS(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteTipoICMS: false,
    tipoICMSDelete: new TipoICMS(),
    indiceTipoICMSDelete: 0,
    ID_TELA_DE_TIPO_ICMS: ID_TELA_DE_TIPO_ICMS
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadTipoICMSs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar TipoICMSs cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadTipoICMSs() {
      this.loading = true
      const response = await TipoICMSService.getAll()
      this.tipoICMSs = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarTipoICMS(tipoICMS) {
      if (!tipoICMS) return

      const indice = this.tipoICMSs.findIndex(
        (tipoICMSExistente) => tipoICMSExistente.id === tipoICMS.id
      )
      if (indice === -1) {
        this.tipoICMSs.push(tipoICMS)
        this.snackbar.snackTextParam = 'Tipo ICMS criado com sucesso.'
      } else {
        this.tipoICMSs.splice(indice, 1, tipoICMS)
        this.snackbar.snackTextParam = 'Tipo ICMS atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteTipoICMS(indice) {
      this.tipoICMSDelete = this.tipoICMSs[indice]
      if (!this.tipoICMSDelete.id) return

      this.indiceTipoICMSDelete = indice
      this.dialogDeleteTipoICMS = true
    },

    async removerTipoICMS() {
      try {
        await TipoICMSService.deleteById(this.tipoICMSDelete.id)
        this.snackbar.snackTextParam = 'TipoICMS removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.tipoICMSs.splice(this.indiceTipoICMSDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteTipoICMS = false
    },

    abrirDialogCriarTipoICMS() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.tipoICMSParam = new TipoICMS()
      this.showDialogParam = true
    },

    abrirDialogEditarTipoICMS(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.tipoICMSParam = { ...this.tipoICMSs[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
